import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { Employee, EmployeeFormBuilder } from 'src/app/feature-module/employees/models/Employee';
import { EmployeeService } from 'src/app/feature-module/employees/service/employee.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';

@Component({
  selector: 'app-employee-manage',
  templateUrl: './employee-manage.component.html',
  styleUrls: ['./employee-manage.component.scss']
})
export class EmployeeManageComponent implements OnInit {
  


  constructor(private activatedRoute:ActivatedRoute, 
    private employeeService: EmployeeService,
    private fb: UntypedFormBuilder, 
    private formUtilsService: FormUtilsService, public uiNotification: UiNotificationService) { }

  employee: Employee;
  editDataForm: UntypedFormGroup;
  columns = 3;

  @Input() employeeId:number;
  
  ngOnInit(): void {
    this.editDataForm = EmployeeFormBuilder.getForm(this.fb, EmployeeFormBuilder.initEmployee() );
    this.loadData();
  }

  loadData() {
    if(!this.employeeId){
      this.employeeId = this.activatedRoute.snapshot.params.id;
    }

    this.employeeService.getEmployee(this.employeeId).subscribe(
      data => {
      this.employee = data;
      this.editDataForm = EmployeeFormBuilder.getForm(this.fb, this.employee ); 
    });
  }

  update() {

    if(!this.formUtilsService.markFormGroupTouched(this.editDataForm)){
      this.uiNotification.showValidationError();
      return;
    }
    
    Object.assign(this.employee, this.editDataForm.value);

      this.employeeService.storeEmployee(this.employee).subscribe(
        () => {   this.uiNotification.showSuccess('validations.dataUpdatedSuccesfully');
        this.loadData(); });
  }
}
